import { RoutingFeatures } from '../../ui/components/navigation/routingfeature';
import { BaseContext } from '../basecontext';

export interface HandleRedirection
{
    isRedirectionRequired(): boolean;
    routeNextFeature(routingFeature: RoutingFeatures, isRedirectionRequired: boolean): void; 
    redirect(): void;
}

export class HandleRedirectionImpl implements HandleRedirection
{
    private isRedirect: boolean;
    private redirectionUrl: string = ""; 

    constructor(private context: BaseContext)
    {
        this.isRedirect = false;
    }

    isRedirectionRequired(): boolean 
    {
        return this.isRedirect;
    }    

    routeNextFeature(routingFeature: RoutingFeatures, isRedirectionRequired: boolean): void 
    {
        isRedirectionRequired ? (this.redirectionUrl = location.pathname) + window.location.search : "";

        this.context.getRouterHistory().push(routingFeature);
    }

    redirect(): void 
    {
        this.context.getRouterHistory().push(this.redirectionUrl);

        this.isRedirect = false;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/redirection/handleredirection.ts